/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace levy
*/
var levy = {};

/**
* @name cdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/cdf}
*/
import cdf from './../../../../base/dists/levy/cdf';
setReadOnly( levy, 'cdf', cdf );

/**
* @name Levy
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/ctor}
*/
import Levy from './../../../../base/dists/levy/ctor';
setReadOnly( levy, 'Levy', Levy );

/**
* @name entropy
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/entropy}
*/
import entropy from './../../../../base/dists/levy/entropy';
setReadOnly( levy, 'entropy', entropy );

/**
* @name logcdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/logcdf}
*/
import logcdf from './../../../../base/dists/levy/logcdf';
setReadOnly( levy, 'logcdf', logcdf );

/**
* @name logpdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/logpdf}
*/
import logpdf from './../../../../base/dists/levy/logpdf';
setReadOnly( levy, 'logpdf', logpdf );

/**
* @name mean
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/mean}
*/
import mean from './../../../../base/dists/levy/mean';
setReadOnly( levy, 'mean', mean );

/**
* @name median
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/median}
*/
import median from './../../../../base/dists/levy/median';
setReadOnly( levy, 'median', median );

/**
* @name mode
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/mode}
*/
import mode from './../../../../base/dists/levy/mode';
setReadOnly( levy, 'mode', mode );

/**
* @name pdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/pdf}
*/
import pdf from './../../../../base/dists/levy/pdf';
setReadOnly( levy, 'pdf', pdf );

/**
* @name quantile
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/quantile}
*/
import quantile from './../../../../base/dists/levy/quantile';
setReadOnly( levy, 'quantile', quantile );

/**
* @name stdev
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/stdev}
*/
import stdev from './../../../../base/dists/levy/stdev';
setReadOnly( levy, 'stdev', stdev );

/**
* @name variance
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/variance}
*/
import variance from './../../../../base/dists/levy/variance';
setReadOnly( levy, 'variance', variance );


// EXPORTS //

export default levy;
